import React from "react";
import ProgressSvg from "../../../assets/svgicons/progress-bar/progress_bar_3_3.svg";

const Progress_3_3 = (props) => {
  return <img src={ProgressSvg} alt="Progress 3-3" {...props} />;
};

export default Progress_3_3;
